<template>
    <v-row>
        <v-col cols="12">
            <div class="plan-value">
                {{ $t('common.plans_and_values') }}
            </div>
            <div class="choose-plan">
                {{ $t('common.choose_your_plan') }}
            </div>
        </v-col>
        <v-col cols="12" class="text-center">
            <div class="p-relative d-inline-block">
                <v-switch inset v-model="isYear" class="d-inline-block"/>
                <div class="left-switch">{{ $t('common.monthly') }}</div>
                <div class="right-switch">{{ $t('common.annual') }}</div>
            </div>
        </v-col>
        <v-col cols="12" v-if="withCoupon">
            <v-row>
                <v-col cols="12" :md="stepperMode ? 12 : 6" :offset-md="stepperMode ? 0 : 3" lg="6" offset-lg="3" class="pb-1">
                    <kimsa-text-field
                        outlined dense force-value
                        :placeholder="$t('common.write_coupon')"
                        :value="couponId"
                        @change="couponId = $event"
                        color="#99CC00"
                    >
                        <template v-slot:append>
                            <v-btn @click="getCouponInfoFromStripe" class="normal-btn" text small :disabled="!couponId">
                                {{ couponApplied ? $t('common.remove') : $t('common.apply') }}
                                <v-icon right>{{ couponApplied ? 'mdi-close' : 'mdi-check' }}</v-icon>
                            </v-btn>
                        </template>
                    </kimsa-text-field>
                    <v-overlay z-index="50" :value="loadingCoupon">
                        <v-progress-circular color="primary" indeterminate size="64"/>
                    </v-overlay>
                </v-col>
                <v-col v-if="messageCoupon" cols="12" class="pt-0 text-center">
                    <small>{{ messageCoupon }}</small>
                </v-col>
            </v-row>
        </v-col>
        <v-col cols="12" :md="stepperMode ? 12 : 6" :lg="stepperMode ? 6 : 4" v-for="(plan,i) in availablePlans" :key="i">
            <subscription-card :plan="plan" class="ma-0" :discount="percent_off" :is-active="isActivePlan(plan)" @plan="onChangePlan" :stepper-mode="stepperMode"/>
        </v-col>
        <v-col cols="12" v-if="availablePlans.length === 0" class="text-center">
            {{ $t('common.no_available_plans') }}
        </v-col>
    </v-row>
</template>

<script>

import KimsaTextField from "@/components/common/inputs/KimsaTextField";
import {mapActions, mapState} from "vuex";
import firebase from "@/utils/Firebase";
import SubscriptionCard from "@/components/elements/cards/SubscriptionCard";

export default {
    name: "SelectPlan",
    components: {SubscriptionCard, KimsaTextField},
    props: {
        withCoupon: {
            type: Boolean,
            default: false,
        },
        stepperMode: {
            type: Boolean,
            default: false,
        }
    },
    data() {
        return {
            isYear: false,
            couponId: null,
            loadingCoupon: false,
            percent_off: null,
            messageCoupon: '',
            couponApplied: false,
            selectedPlan: null,
        }
    },
    computed: {
        ...mapState(['plans']),
        availablePlans(vm = this) {
            return vm.plans?.filter(plan => vm.isYear ? plan.intervalType === 'annual' : plan.intervalType === 'monthly') || []
        },
        priceId(vm = this) {
            return vm.account?.stripeAccount?.currentSubscription?.priceId || null
        }
    },
    async mounted() {
        const vm = this
        await vm.loadPlans()
        // console.log('select', vm)
    },
    methods: {
        ...mapActions(['bindPlans', 'bindCompanyPlans']),
        async loadPlans() {
            const vm = this
            if (vm.plans.length === 0 && vm.account) {
                vm.account.accountType === 'company' ?
                    await vm.bindCompanyPlans() :
                    await vm.bindPlans()
            }
        },
        isActivePlan(plan) {
            const vm = this
            if (vm.stepperMode) return plan.priceId === vm.selectedPlan?.priceId
            return plan.priceId === vm.priceId
        },
        onChangePlan(plan) {
            const vm = this
            vm.selectedPlan = plan
            vm.$emit('change', plan)
            vm.$emit('plan')
        },
        getCouponInfo: firebase.functions().httpsCallable('httpPayments-getCouponInfo'),
        async getCouponInfoFromStripe() {
            const vm = this

            if (!vm.couponId) return

            if(vm.couponApplied) {
                vm.couponId = null
                vm.percent_off = null
                vm.couponApplied = false
                vm.$emit('coupon', null)
                vm.messageCoupon = ''
                return
            }

            vm.loadingCoupon = true
            // console.log('couponId', vm.couponId)
            await vm.getCouponInfo({couponId: vm.couponId}).then(result => {
                // console.log('coupon result', result)
                let data = result.data
                if (data.id) {
                    if (data.times_redeemed === data.max_redemptions) return vm.messageCoupon = vm.$t('payment_failed_messages.coupon_maximum_redeem')
                    if (!data.valid) return vm.messageCoupon = vm.$t('payment_failed_messages.coupon_invalid')
                    vm.messageCoupon = `${vm.$t('common.coupon_obtained')} ${data.name}`
                    vm.percent_off = data.percent_off
                    vm.couponApplied = true
                    vm.$emit('coupon', data.id)
                } else {
                    vm.messageCoupon = data.message
                }
            }).catch(err => {
                console.log(`Error cupón: ${err.message}`)
            }).finally(() => {
                vm.loadingCoupon = false
            })
        },
    },
    watch: {
        account() {
            this.loadPlans()
        }
    }
}
</script>

<style scoped>

.plan-value {
    font-weight: 700;
    font-size: 14px;
    line-height: 16px;
    color: #078571;
    text-align: center;
}

.choose-plan {
    font-weight: 700;
    font-size: 30px;
    line-height: 42px;
    color: #170F49;
    text-align: center;
}

::v-deep .v-input--switch__track {
    background: linear-gradient(180deg, #CCFF99 0%, #99CC00 100%);
    opacity: 1;
}

::v-deep .v-input--switch__thumb {
    background: #ffffff;
}

.left-switch {
    position: absolute;
    left: -80px;
    top: 22px;
    font-weight: 400;
    color: #170F49;
}

.right-switch {
    position: absolute;
    right: -40px;
    top: 22px;
    font-weight: 400;
    color: #170F49;
}

</style>